import { createSelector, createSlice } from '@reduxjs/toolkit';

import { FeatureFlagUser } from '@/types';

import { RootState } from '../store';

import { syncNativeAppContext } from './appSlice';

export interface FeatureFlagState {
  user: FeatureFlagUser | null;
  userLoaded: boolean;
}

const initialState: FeatureFlagState = {
  user: null,
  userLoaded: false,
};

export const featureFlagSlice = createSlice({
  name: 'featureFlag',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(syncNativeAppContext.fulfilled, (state, { payload }) => {
      state.user = payload.featureFlagUser ?? null;
    });

    builder.addMatcher(syncNativeAppContext.settled, (state) => {
      state.userLoaded = true;
    });
  },
});

export default featureFlagSlice.reducer;

export const getFeatureFlagState = (state: RootState) => state.featureFlag;

export const getFeatureFlagUser = createSelector(getFeatureFlagState, (state) => state.user);

export const getOptimizelyUser = createSelector(getFeatureFlagUser, (state) => ({
  id: state?.userId ?? null,
  attributes: state?.attributes,
}));

export const getFeatureFlagUserLoaded = createSelector(
  getFeatureFlagState,
  (state) => state.userLoaded
);
